import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from '@/lib/auth';

import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';
import ProtectedRoute from '@/components/ProtectedRoute';

import Home from '@/pages/Home';
import About from '@/pages/About';
import Schools from '@/pages/Schools';
import Programs from '@/pages/Programs';
import ProgramDetail from '@/pages/ProgramDetail';
import Admissions from '@/pages/Admissions';
import StudentServices from '@/pages/StudentServices';
import Contact from '@/pages/Contact';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import AuthCallback from '@/pages/AuthCallback';
import StudentDashboard from '@/pages/StudentDashboard';
import CoursePlayer from '@/pages/CoursePlayer';
import AdminDashboard from '@/pages/AdminDashboard';
import VerifyCertificate from '@/pages/VerifyCertificate';
import LegalPage from '@/pages/Legal';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';
import PaymentSuccess from '@/pages/PaymentSuccess';
import Transcript from '@/pages/Transcript';
import StudentHandbookPage from '@/pages/StudentHandbook';

import '@/App.css';

function Shell() {
  const location = useLocation();
  // Hide nav/footer on full-screen experiences
  const fullScreen = location.pathname.startsWith('/admin') || location.pathname.startsWith('/learn') || location.pathname.startsWith('/auth/callback');
  // Critical: detect session_id during render (synchronous) so AuthCallback runs first
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <>
      {!fullScreen && <Navbar />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/schools" element={<Schools />} />
        <Route path="/programs" element={<Programs />} />
        <Route path="/programs/:slug" element={<ProgramDetail />} />
        <Route path="/admissions" element={<Admissions />} />
        <Route path="/student-services" element={<StudentServices />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />

        <Route path="/dashboard" element={<ProtectedRoute><StudentDashboard /></ProtectedRoute>} />
        <Route path="/dashboard/transcript" element={<ProtectedRoute><Transcript /></ProtectedRoute>} />
        <Route path="/learn/:course_id" element={<ProtectedRoute><CoursePlayer /></ProtectedRoute>} />

        <Route path="/admin/*" element={<ProtectedRoute requireAdmin><AdminDashboard /></ProtectedRoute>} />

        <Route path="/verify/:certificate_number" element={<VerifyCertificate />} />
        <Route path="/legal/:page" element={<LegalPage />} />
        <Route path="/student-handbook" element={<StudentHandbookPage />} />

        <Route path="*" element={<Home />} />
      </Routes>
      {!fullScreen && <Footer />}
    </>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <div className="App font-body">
          <Shell />
          <Toaster richColors position="top-right" />
        </div>
      </AuthProvider>
    </BrowserRouter>
  );
}
